import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field, formValueSelector} from 'redux-form';
import {Card, Button, Form, Grid, Loader, Icon, Input, Select} from 'semantic-ui-react';
import {Actions} from '../../../../../common/actions';
import {PART} from '../../../../../common/forms';
import {CheckboxField} from '../../../../../common/components/form';
import {toFloat} from '../../../../../common/util/fieldsNormalization';
import {partClassification} from '../../../../../common/dictionaries/classification';
import {resources, scopes} from '../../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../../common/permissions/validations';
import {paths} from '../../../../../common/dictionaries/urls';
import DatePickerField from '../../../../../common/components/form/datePicker';
import OrdersAndSalesChart from '../chart';
import BackOrdersModal from '../modals/backOrders';
import OnOrdersModal from '../modals/onOrders';
import MADInfoModal from '../modals/madInfo';
import PartInfo from './partInfo';
import PartPrice from './partPrice';
import PartDescription from './partDescription';
import PartTMC from './partTMC';

class PartAnalysisForm extends Component {
  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.PartAnalysis, scopes.See) &&
      !hasAccessPermission(this.props.permissions, resources.PartAnalysis, scopes.Edit)) {
      this.props.push(paths.AccessDenied);
    }
    const {code} = this.props;
    this.props.fetchAnalysis(code);
    this.props.getPartWeeklyMoves(code);
  }

  componentDidUpdate(prevProps) {
    const {code} = this.props;
    if (code !== prevProps.code) {
      this.props.fetchAnalysis(code);
      this.props.getPartWeeklyMoves(code);
    }
  }

  onActiveBarClick(type, week) {
    const {code} = this.props;
    this.props.fetchWeeklyAnalysis(code, type, week);
  }

  onCancelClick() {
    this.props.goBack();
  }

  renderLabel(width, label, paddingLeft) {
    const classes = paddingLeft ? 'padding-left' : '';
    return (
      <Grid.Column width={width} className={classes}>
        <span className='bolder'>{label}</span>
      </Grid.Column>
    );
  }

  renderNumericValue(width, value = 0) {
    return <Grid.Column width={width}>{value}</Grid.Column>;
  }

  renderClassificationSelect = (field) => {
    return (
      <Select
        options={field.options}
        value={field.input.value}
        disabled={!hasAccessPermission(this.props.permissions, resources.PartAnalysis, scopes.Edit)}
        onChange={(e, {value}) => field.input.onChange(value)}
      />
    );
  };

  getClassificationData() {
    return Object.keys(partClassification).map((element) => {
      return {'text': partClassification[element], 'value': element};
    });
  }

  renderDatePicker({input}) {
    return <DatePickerField input={input} />;
  }

  renderSaveButton() {
    if (!hasAccessPermission(this.props.permissions, resources.PartAnalysis, scopes.Edit)) {
      return null;
    }
    const {submitting} = this.props;
    return (
      <Button primary type='submit' disabled={submitting}>
        Guardar
      </Button>
    );
  }

  renderLoader() {
    return (
      <Loader active inline='centered'>
        Consultando información...
      </Loader>
    );
  }

  renderWeeklyChart() {
    const {loadingWeeklyAnalysis, weeklyAnalysis, weeklyMoves, loadingWeeklyMoves} = this.props;

    if (!loadingWeeklyMoves) {
      return (
        <OrdersAndSalesChart
          orders
          sales
          data={weeklyMoves || []}
          loadingWeeklyAnalysis={loadingWeeklyAnalysis}
          weeklyAnalysis={weeklyAnalysis || []}
          activeBarClick={this.onActiveBarClick.bind(this)}
        />
      );
    }
    this.renderLoader();
  }

  renderManualMad() {
    const {isManualMadActive} = this.props;
    if (isManualMadActive) {
      return (
        <Fragment>
          <Grid.Column width={2}>
            <Field
              name='manualMad'
              component={Input}
              maxLength='10'
              type='number'
              min='0'
              step='0.01'
              pattern='^\d+(?:\.\d{1,2})?$'
              disabled={
                !hasAccessPermission(this.props.permissions, resources.PartAnalysis, scopes.Edit)
              }
              normalize={toFloat}
            />
          </Grid.Column>
          {this.renderLabel(1, '')}
          {this.renderLabel(3, 'Vigente hasta')}
          <Grid.Column width={5}>
            <Field name='manualMadValidity' component={this.renderDatePicker} />
          </Grid.Column>
        </ Fragment>
      );
    }
  }

  render() {
    const {handleSubmit, submitting, code, loading, data, isMenuExpanded, permissions, push} = this.props;
    const titleClasses = isMenuExpanded ? 'title-section' : 'title-section narrow';

    return (
      <Form className='part-analysis-form' onSubmit={handleSubmit}>
        <Card raised className={titleClasses}>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick.bind(this)} />
              <h2>{code}</h2>
              <div className='title-bar-actions'>
                <Button
                  secondary
                  type='button'
                  onClick={this.onCancelClick.bind(this)}
                  disabled={submitting}
                >
                  Cancelar
                </Button>
                {this.renderSaveButton()}
              </div>
            </div>
            <div className='subtitle'>
              {data.franchise} | {data.name} | {data.origin}
            </div>
          </div>
        </Card>
        <Card raised fluid className='data-section'>
          {loading && this.renderLoader()}
          {!loading && (
            <div className='primary-content'>
              <Grid textAlign='left'>
                <PartInfo code={code} data={data} push={push} />
                <Grid.Row columns={2} className='border-bottom row-content'>
                  <Grid.Column>
                    <Grid columns='equal'>
                      <Grid.Row>
                        {this.renderLabel(3, 'MAD Pedido')}
                        <MADInfoModal value={data.ordersMad} typeInfo='Pedidos' MADCalculo={data.calculoMadPedidos} />
                        {this.renderLabel(5, 'Meses Stock Pedido')}
                        {this.renderNumericValue(3, data.ordersMonthStock)}
                      </Grid.Row>
                      <Grid.Row>
                        {this.renderLabel(3, 'MAD Venta')}
                        <MADInfoModal value={data.salesMad} typeInfo='Ventas' MADCalculo={data.calculoMadVentas}/>
                        {this.renderLabel(5, 'Meses Stock Venta')}
                        {this.renderNumericValue(3, data.salesMonthStock)}
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                  <Grid.Column>
                    <Grid columns='equal'>
                      <Grid.Row>
                        {this.renderLabel(4, 'MIP Pedido', true)}
                        {this.renderNumericValue(4, data.ordersMip)}
                        {this.renderLabel(4, 'MIP Venta')}
                        {this.renderNumericValue(4, data.salesMip)}
                      </Grid.Row>
                      <Grid.Row>
                        {this.renderLabel(3, 'MAD Manual', true)}
                        <Grid.Column width={2}>
                          <Field
                            type='toggle'
                            name='manualMadStatus'
                            component={CheckboxField}
                            disabled={!hasAccessPermission(this.props.permissions, resources.PartAnalysis, scopes.Edit)}
                          />
                        </Grid.Column>
                        {this.renderManualMad()}
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={2} divided className='row-content'>
                  <Grid.Column>
                    <PartPrice data={data} permissions={permissions} />
                    <Grid columns='equal' className='padding-top'>
                      <Grid.Row>
                        {this.renderLabel(3, 'Clasificación')}
                        <Grid.Column width={5}>
                          <Field
                            name='classification'
                            component={this.renderClassificationSelect}
                            options={this.getClassificationData()}
                          />
                        </Grid.Column>
                        {this.renderLabel(4, 'On / Order')}
                        <Grid.Column width={4}>
                          <OnOrdersModal
                            code={code}
                            quantity={data.onOrder || 0}
                            quantityConfirmed={data.onOrderConfirmed || 0}
                          />
                        </Grid.Column>
                      </Grid.Row>
                      <Grid.Row>
                        {this.renderLabel(6, 'Aplica Cambio de precio ')}
                        <Grid.Column width={2}>
                          <Field
                            type='toggle'
                            name='appliesPriceChange'
                            component={CheckboxField}
                            disabled={!hasAccessPermission(this.props.permissions, resources.PartAnalysis, scopes.Edit)}
                          />
                        </Grid.Column>
                        {this.renderLabel(4, 'Back Orders')}
                        <Grid.Column width={4}>
                          <BackOrdersModal code={code} quantity={data.backOrders || 0} />
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                  <Grid.Column>
                    <PartTMC data={data}/>
                    <PartDescription data={data}/>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          )}
        </Card>
        <Card raised fluid>
          {this.renderWeeklyChart()}
        </Card>
      </Form>
    );
  }
}

export {PartAnalysisForm};

const form = reduxForm({
  'form': PART.name,
})(PartAnalysisForm);

const mapStateToProps = (state, ownProps) => {
  const selector = formValueSelector(PART.name);
  const isManualMadActive = selector(state, 'manualMadStatus');
  return {
    isManualMadActive,
    'loading': state.form.part.loading,
    'loadingWeeklyMoves': state.form.part.loadingWeeklyMoves,
    'data': state.form.part.selectedPartData,
    'loadingWeeklyAnalysis': state.form.part.loadingWeeklyAnalysis,
    'weeklyAnalysis': state.form.part.weeklyAnalysis,
    'weeklyMoves': state.form.part.weeklyMoves,
    'isMenuExpanded': state.menu.expanded,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
  };
};

const {fetchAnalysis, fetchWeeklyAnalysis, getPartWeeklyMoves} = Actions;

export default connect(mapStateToProps, {
  fetchAnalysis,
  fetchWeeklyAnalysis,
  getPartWeeklyMoves,
})(form);
